import { easeCurves } from "../eases/eases";
import { css } from 'styled-components';
/**
 * A simple generic animation can be completely customized
 * Available css variables for consumption by children:
 * ```
 * --vapor-generic-transition-ease
 * --vapor-generic-transition-duration
 * --vapor-generic-x
 * --vapor-generic-y
 * --vapor-generic-scale
 *```
 * Optional configurations:
 
 *
 * @param {boolean} isActive toggles animation between the two states.
 *
 *```jsx
 * <MyComponent isActive={true} >
 * {...children}
 * </MyComponent>
 *```
 */

export var transitionGeneric = function transitionGeneric() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$opacityActive = props.opacityActive,
      opacityActive = _props$opacityActive === void 0 ? 1 : _props$opacityActive,
      _props$opacityDefault = props.opacityDefault,
      opacityDefault = _props$opacityDefault === void 0 ? 1 : _props$opacityDefault,
      _props$scaleActive = props.scaleActive,
      scaleActive = _props$scaleActive === void 0 ? 1 : _props$scaleActive,
      _props$scaleDefault = props.scaleDefault,
      scaleDefault = _props$scaleDefault === void 0 ? 1 : _props$scaleDefault,
      _props$offsetActiveX = props.offsetActiveX,
      offsetActiveX = _props$offsetActiveX === void 0 ? '0px' : _props$offsetActiveX,
      _props$offsetDefaultX = props.offsetDefaultX,
      offsetDefaultX = _props$offsetDefaultX === void 0 ? '0px' : _props$offsetDefaultX,
      _props$offsetActiveY = props.offsetActiveY,
      offsetActiveY = _props$offsetActiveY === void 0 ? '0px' : _props$offsetActiveY,
      _props$offsetDefaultY = props.offsetDefaultY,
      offsetDefaultY = _props$offsetDefaultY === void 0 ? '0px' : _props$offsetDefaultY,
      _props$durationActive = props.durationActive,
      durationActive = _props$durationActive === void 0 ? 200 : _props$durationActive,
      _props$durationDefaul = props.durationDefault,
      durationDefault = _props$durationDefaul === void 0 ? 200 : _props$durationDefaul,
      _props$easeIn = props.easeIn,
      easeIn = _props$easeIn === void 0 ? 'primary' : _props$easeIn,
      _props$easeOut = props.easeOut,
      easeOut = _props$easeOut === void 0 ? 'primary' : _props$easeOut;
  return css(["--vapor-generic-transition-ease:", ";--vapor-generic-transition-duration:", ";--vapor-generic-x:", ";--vapor-generic-y:", ";--vapor-generic-scale:", ";opacity:", ";transform:translate3d(var(--vapor-generic-x),var(--vapor-generic-y),0px) scale(var(--vapor-generic-scale));transition-property:transform,opacity;transition-timing-function:var(--vapor-generic-transition-ease);transition-duration:var(--vapor-generic-transition-duration);"], function (p) {
    return p.isActive ? easeCurves[easeIn] : easeCurves[easeOut];
  }, function (p) {
    return p.isActive ? "".concat(durationActive, "ms") : "".concat(durationDefault, "ms");
  }, function (p) {
    return p.isActive ? offsetActiveX : offsetDefaultX;
  }, function (p) {
    return p.isActive ? offsetActiveY : offsetDefaultY;
  }, function (p) {
    return p.isActive ? scaleActive : scaleDefault;
  }, function (p) {
    return p.isActive ? opacityActive : opacityDefault;
  });
};